<template>
  <div>
    <div style="margin-top: 5px">
      <div style="margin-bottom: -20px; position: relative; z-index: 1">
        <span v-if="activeTabName === 'packageTab'">
          <el-select
              class="button-left"
              v-model="dataSearch.usingStatus"
              @change="searchPackageProperties()"
              placeholder="Chọn trạng thái"
          >
            <el-option label="Đang sử dụng" :value="true"></el-option>
            <el-option label="Ngừng sử dụng" :value="false"></el-option>
          </el-select>
            <el-select
                class="button-left"
                v-model="dataSearch.category"
                @change="searchPackageProperties()"
                placeholder="Chọn loại"
                clearable
            >
            <el-option label="Thu" value="in"></el-option>
            <el-option label="Chi" value="out"></el-option>
          </el-select>
          <el-input
              style="width: 300px"
              placeholder="Nhập tên khoản"
              clearable
              v-model="dataSearch.name"
              @clear="searchPackageProperties()"
              @keyup.enter.native="searchPackageProperties()"
          >
            <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchPackageProperties()"
            ></el-button>
          </el-input>
        </span>
        <el-input
            v-else-if="activeTabName === 'classPackageTab'"
            style="width: 300px"
            placeholder="Nhập tên lớp"
            clearable
            v-model="className"
            @clear="fetchDataClassSearchPackage('')"
            @change="searchClassPackageByProperties()"
        >
          <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchClassPackageByProperties()"
          ></el-button>
        </el-input>
        <el-input
            v-else-if="activeTabName === 'groupPackageTab'"
            style="width: 300px"
            placeholder="Nhập tên nhóm"
            clearable
            v-model="className"
            @clear="fetchDataClassSearchPackage('')"
            @change="searchGroupPackageByProperties()"
        >
          <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchGroupPackageByProperties()"
          ></el-button>
        </el-input>
      </div>
      <el-tabs type="card" @tab-click="handleClickTab" v-model="activeTabName">
        <!-- thiết lập khoản -->
        <el-tab-pane label="Thiết lập thu lớp" name="classPackageTab">
          <el-table
              ref="multipleTable"
              highlight-current-row
              :empty-text="textTable"
              v-loading="loadingData"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              :data="responseClassList"
              :cell-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              :max-height="$tableMaxHeight"
              border
          >
            <el-table-column
                fixed
                type="index"
                label="STT"
                width="50"
                align="center"
            ></el-table-column>
            <el-table-column
                fixed
                prop="className"
                label="Tên lớp"
                min-width="150"
            ></el-table-column>
            <el-table-column
                prop="grade.gradeName"
                label="Tên khối"
                min-width="150"
            ></el-table-column>
            <el-table-column
                prop="number"
                align="center"
                label="Số khoản"
                min-width="150"
            ></el-table-column>
            <el-table-column label="Tác vụ" fixed="right" width="160" align="center">
              <template v-slot:default="scope">
                <el-button size="mini" type="success" @click="addDialogMethod(scope.row, 'class')"
                >Thêm khoản
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="Thiết lập thu nhóm" name="groupPackageTab">
          <el-table
              ref="multipleTable"
              highlight-current-row
              :empty-text="textTable"
              v-loading="loadingData"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              :data="responseGroupList"
              :cell-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              :max-height="$tableMaxHeight"
              border
          >
            <el-table-column
                fixed
                type="index"
                label="STT"
                width="50"
                align="center"
            ></el-table-column>
            <el-table-column
                fixed
                prop="groupName"
                label="Tên nhóm"
                min-width="150"
            ></el-table-column>
            <el-table-column
                prop="number"
                align="center"
                label="Số khoản"
                min-width="150"
            ></el-table-column>
            <el-table-column label="Tác vụ" fixed="right" width="160" align="center">
              <template v-slot:default="scope">
                <el-button size="mini" type="success" @click="addDialogMethod(scope.row, 'group')"
                >Thêm khoản
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- quản lý khoản -->
        <el-tab-pane label="Danh sách khoản" name="packageTab">
          <el-table
              ref="multipleTable"
              :empty-text="textTable"
              v-loading="loadingData"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              highlight-current-row
              :data="responsePackageList"
              :cell-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              :max-height="$tableMaxHeight"
              @selection-change="handleSelectionChange"
              border
          >
<!--            <el-table-column-->
<!--                fixed-->
<!--                type="selection"-->
<!--                align="center"-->
<!--                width="55"-->
<!--            ></el-table-column>-->
            <el-table-column
                fixed
                type="index"
                label="STT"
                width="50"
                align="center"
            ></el-table-column>
            <el-table-column
                fixed
                prop="name"
                label="Tên khoản"
                min-width="190"
            ></el-table-column>
            <el-table-column
                prop="description"
                label="Mô tả"
                min-width="180"
            ></el-table-column>
            <el-table-column label="Loại" align="center" width="90">
              <template slot-scope="scope">
                <span v-if="scope.row.category === 'in'">Thu</span>
                <span v-else-if="scope.row.category === 'out'">Chi</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="number"
                align="center"
                label="Số lượng"
                width="100"
            ></el-table-column>
            <el-table-column prop="price" align="right" label="Đơn giá" width="120">
              <template v-slot:default="scope">
                <span v-if="scope.row.price === 0">0</span>
                <span v-else>{{ scope.row.price | formatCurrency }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="discount" align="center" label="Giảm giá" width="100">
              <template v-slot:default="scope">
                <span v-if="scope.row.discount">Có</span>
                <span v-else>Không</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="discountPrice"
                align="right"
                label="Thành tiền"
                width="130"
            >
              <template v-slot:default="scope">
                <span>
                  <span v-if="scope.row.discountPrice === 0">0</span>
                  <span v-else>{{ scope.row.discountPrice | formatCurrency }}</span></span
                >
              </template>
            </el-table-column>
            <el-table-column
                prop="attendance"
                align="center"
                label="Điểm danh"
                width="95"
            >
              <template v-slot:default="scope">
                <span v-if="scope.row.attendance">Có</span>
                <span v-else>Không</span>
              </template>
            </el-table-column>
            <el-table-column label="Tác vụ" fixed="right" width="220" align="center">
              <template v-slot:default="scope">
                <el-button
                    size="mini"
                    type="success"
                    @click="updateDialogMethod(scope.row)"
                >{{ $t("button.update") }}
                </el-button
                >
                <el-button
                    :disabled="scope.row.usingStatus"
                    size="mini"
                    type="danger"
                    @click="deletePackageMethod(scope.row)"
                >{{ $t("button.delete") }}
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-row type="flex">
            <el-col :span="22" style=" margin: 15px 0">
              <div class="container_nav_page">
                <el-pagination
                    background
                    layout="prev, pager, next, sizes"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentPageChange"
                    :current-page.sync="dataSearch.page"
                    :page-sizes="listSizePage"
                    :total="total">
                </el-pagination>
              </div>
            </el-col>
            <el-col :span="2">
              <div style="float: right; margin: 15px 0">
                <el-dropdown @command="handleCommandAction">
                  <el-button class="button-bottom" type="success">
                    Tác vụ
                    <i class="el-icon-caret-bottom"/>
                  </el-button>
                  <el-dropdown-menu class="el-dropdown-menu-container">
                    <el-dropdown-item command="createRevenue">Tạo khoản</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
    <CreateRevenueDialog
        :dialogVisible="showCreateDialog"
        @dialog-close="dialogCloseCreateMethod()"
        ref="CreateRevenueDialog"
    />
    <UpdateRevenueDialog
        :dialogVisibleUpdate="showUpdateDialog"
        :dataUpdate="dataUpdate"
        :exitClassOrGroup="exitClassOrGroup"
        @dialog-close="dialogCloseUpdateMethod()"
        ref="UpdateRevenueDialog"
    />
    <AddRevenueManagementDialog
        :dialogVisible="showAddDialog"
        @dialog-close="dialogCloseAddMethod()"
        ref="AddRevenueManagementDialog"
    />
  </div>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import CreateRevenueDialog from "@/components/FinanceVer2/TuitionManagement/dialog/CreateRevenueDialog.vue";
import revenueManagementService from "@/services/Finance_Kids_V2/RevenueManagementService";
import UpdateRevenueDialog from "@/components/FinanceVer2/TuitionManagement/dialog/UpdateRevenueDialog.vue";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import AddRevenueManagementDialog
  from "@/components/FinanceVer2/TuitionManagement/dialog/AddRevenueManagementDialog.vue";

export default {
  components: {
    AddRevenueManagementDialog,
    UpdateRevenueDialog,
    CreateRevenueDialog,
  },
  data() {
    return {
      textTable: "",
      loadingData: false,
      activeTabName: "classPackageTab",
      responsePackageList: [],
      responsePackageExtendList: [],
      responsePackageRootList: [],
      multipleSelection: [],
      showCreateDialog: false,
      showCreateExtendDialog: false,
      showUpdateRootDialog: false,
      showUpdateDialog: false,
      showAddDialog: false,
      dataUpdate: {},
      dataSearch: {
        name: "",
        usingStatus: true,
        category: "",
        limit: 20,
        page: 1,
      },
      listSizePage: [20, 30, 40, 50, 100],
      total: 0,
      dataExtendSearch: {
        name: "",
      },
      className: "",
      groupName: "",
      responseClassList:[],
      responseGroupList:[],
      type: "",
      exitClassOrGroup: false,
    };
  },
  created() {
    this.$store.dispatch('classStore/fetchDataClassSearchPackage', this.className)
  },
  methods: {
    ...mapActions('classStore', ['fetchDataClassSearchPackage']),
    ...mapMutations('classStore', ['SET_ClassSearchPackage']),
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    tableRowStyle({row}) {
      if (row.category === "out") {
        return "color: #409EFF";
      }
    },
    handleClickTab(tab) {
      let tabNameClick = tab.name;
      if (tabNameClick === "classPackageTab") {
        this.searchClassPackageByProperties();
      } else if (tabNameClick === "packageTab") {
        this.searchPackageProperties();
      }else if (tabNameClick === "groupPackageTab") {
        this.searchGroupPackageByProperties();
      }

    },
    dialogCloseCreateMethod() {
      this.showCreateDialog = false;
      this.searchPackageProperties();
    },
    dialogCloseUpdateMethod() {
      this.showUpdateDialog = false;
      this.searchPackageProperties();
    },
    dialogCloseAddMethod() {
      this.showAddDialog = false;
      if (this.type === 'class'){
        this.searchClassPackageByProperties();
      } else {
        this.searchGroupPackageByProperties();
      }
    },
    updateDialogMethod(row) {
      this.exitClassOrGroup = row.exitClassOrGroup
      this.dataUpdate = row;
      this.showUpdateDialog = true;
    },
    addDialogMethod(row, type) {
      this.showAddDialog = true;
      this.type = type;
      this.$refs.AddRevenueManagementDialog.getAddDataInitial(row, type);
    },
    //select rows
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    handleCommandAction(command) {
      if (command === "createRevenue") {
        this.createDialogMethod();
      }
    },
    /**
     * thêm khoản
     */
    createDialogMethod() {
      this.showCreateDialog = true;
    },
    /**
     * xóa khoản
     */
    deletePackageMethod(row) {
      this.$confirm("Bạn có chắc chắn muốn xóa khoản này?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      }).then(() => {
        revenueManagementService.deleteRevenueManagement(row.id)
            .then(() => {
              NotifyMessage.leftCornerNotificationSuccess("Xóa thành công!")
              this.searchPackageProperties();
            })
            .catch((err) => {
              console.log(err)
              NotifyMessage.leftCornerNotificationError("Xóa thất bại");
            });
      });
    },
    searchPackageProperties() {
      this.loadingData = true;
      revenueManagementService.findAllRevenueManagement(
          this.dataSearch.usingStatus,
          this.dataSearch.name,
          this.dataSearch.category,
          this.dataSearch.limit,
          this.dataSearch.page
      )
          .then((resp) => {
            this.responsePackageList = resp.data.data.managementResponseList;
            this.total = resp.data.data.total
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
            this.responsePackageList = [];
          })
          .finally(() => {
            if (this.responsePackageList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            this.loadingData = false;
          });
    },
    /**
     * Phân trang
     */
    handleSizeChange(value) {
      this.dataSearch.limit = value;
      this.searchPackageProperties();
    },
    handleCurrentPageChange(value) {
      this.dataSearch.page = value;
      this.searchPackageProperties();
    },

    searchClassPackageByProperties() {
      revenueManagementService.findClassRevenueManagement(this.className)
          .then(response => {
            this.responseClassList = response.data.data;
          }).catch(error => {
        console.log(error);
      });

    },

    /**
     * tìm kiếm tất cả các quyền cho người dùng
     */
    searchGroupPackageByProperties() {
      revenueManagementService.findGroupRevenueManagement(this.groupName)
          .then(response => {
            this.responseGroupList = response.data.data;
          }).catch(error => {
        console.log(error);
      });

    },
  },

  beforeMount() {
    this.searchClassPackageByProperties();
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #78a5e7;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-tabs__nav-scroll {
  float: right;
}

/deep/ .el-tabs__header {
  margin-bottom: 0;
}

/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #78a5e7;
}

/deep/ .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}


/deep/ .el-checkbox__inner {
  border: 1px solid gray;
}

.input-common {
  margin-right: 5px;
}

.button-bottom {
  border-radius: 0;
  margin-left: 3px;
}

.button-click {
  float: right;
  margin: 20px 0 40px 0;
}

.el-dropdown-menu {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 0;
  margin: 3px 0;
  background-color: #5fb44a;
  border: 1px solid #ebeef5;
  border-radius: 0;
  box-shadow: 0 2px 12px 0 #0000001a;
}

.el-dropdown-menu li {
  color: white;
  border-top: 1px solid white;
  font-family: Arial, Helvetica, sans-serif;
}

.over-table {
  width: 97%;
  margin: 0 auto;
}

.table-data {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ebeef5;
}

.wrapper-table {
  height: 600px;
  overflow-y: scroll;
  border-bottom: 1px solid #ebeef5;
}

thead {
  background: #78a5e7;
  color: white;
  font-weight: bold;
  // display: block;
  // width: 90%;
}

tbody {
  color: #606266;
  font-size: 14px;
  overflow: auto;
  font-family: Arial, Helvetica, sans-serif;
}

// td {
//   padding: 12px;
// }
.table-index {
  width: 10px;
  text-align: center;
}

.table-item-name {
  width: 200px;
  text-align: center;
}

.table-action {
  width: 200px;
  text-align: center;
}

.color-text-reply {
  color: #4177e2;
}

.input-data {
  width: 60%;
}

.disable-row {
  background: #e4e7ed;
}

.button-left {
  margin-right: 5px;
  width: 150px;
}

.container_nav_page {
  display: flex;
  justify-content: center;
}
</style>
